import React, { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { AppErrorBoundary } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { LanguageChanged } from 'omni-package-react-core';
import { ErrorHandler } from 'omni-package-react-logging';

export interface AppLayoutProps {
  children: ReactNode;
}

const AppLayout: FC<AppLayoutProps> = ({ children }) => {
  const { t } = useTranslation('App');
  return (
    <AppErrorBoundary errorTitle={t('ErrorTitle')} message={t('ErrorMessage')} retryButton={t('ErrorRetryButton')}>
      <ErrorHandler />
      <LanguageChanged />
      <Helmet />
      {children}
    </AppErrorBoundary>
  );
};

export default AppLayout;
